import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MoreHorizontalIcon } from 'lucide-react';
import { Pagination, Table, TableSkeleton, TD, TH, THead, TR } from '../ui/Table';
import { SearchInput } from '../ui/SearchInput';
import { schools } from '../../data/district';
import { usePagination } from '../../hooks/usePagination';
export function SchoolsTab({
  loading
}: {
  loading: boolean;
}) {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const rows = useMemo(() => {
    const q = query.trim().toLowerCase();
    return schools.filter(school => school.name.toLowerCase().includes(q));
  }, [query]);
  const {
    page,
    setPage,
    totalPages,
    pageItems
  } = usePagination(rows, 10);
  return <div className="flex flex-1 flex-col" data-id="element-206" data-mp="77y0h1x2y6vs">
      <div className="mb-4" data-id="element-207" data-mp="2b7i27xsyz77">
        <SearchInput value={query} onChange={setQuery} placeholder="Search by school name" className="w-[235px]" data-id="element-208" data-mp="2afzpyt7uxyv" />
      </div>

      <Table minWidth={700} data-id="element-209" data-mp="3uh4dmgoieiuh">
        <THead data-id="element-210" data-mp="uy6r354tvaid">
          <tr data-id="element-211" data-mp="uxnjoict04il">
            <TH data-id="element-212" data-mp="uxx1hinp35d7">School Name</TH>
            <TH data-id="element-213" data-mp="uwvm51znbwpo">Students Covered</TH>
            <TH width={56} data-id="element-214" data-mp="zpx1fb3rly9s" />
          </tr>
        </THead>
        {loading ? <TableSkeleton columns={3} rows={3} data-id="element-215" data-mp="l0slk0kg064u" /> : <tbody data-id="element-216" data-mp="l2c1fq26sf63">
            {pageItems.length === 0 && <TR data-id="element-217" data-mp="pyu6ys5cchjh">
                <TD colSpan={3} className="py-10 text-center text-ink-500" data-id="element-218" data-mp="q0di64c542ee">
                  No schools found
                </TD>
              </TR>}
            {pageItems.map(school => <TR key={school.slug} onClick={() => navigate(`/overview/${school.slug}/students`)} data-id="element-219" data-mp="1inrb7rcpwdt8">
                <TD data-id="element-220" data-mp="14nykvx53rzls">{school.name}</TD>
                <TD data-id="element-221" data-mp="18q3ckqbzqm5s">{school.studentsCovered}</TD>
                <TD data-id="element-222" data-mp="18os9ytua7kg9">
                  <button type="button" aria-label={`Actions for ${school.name}`} onClick={e => {
              e.stopPropagation();
              navigate(`/overview/${school.slug}/students`);
            }} className="inline-flex h-7 w-7 items-center justify-center rounded text-ink-500 hover:bg-ink-100 hover:text-ink-700" data-id="element-223" data-mp="18oa91jwoci20">
                    <MoreHorizontalIcon className="h-4 w-4" data-id="element-224" data-mp="1q70klkl84cia" />
                  </button>
                </TD>
              </TR>)}
          </tbody>}
      </Table>
      <Pagination page={page} totalPages={totalPages} onChange={setPage} data-id="element-225" data-mp="1h6ub09snbwoe" />
    </div>;
}